import styles from './Dimmer.module.scss';
import Loader from 'components/layout/Loader/Loader';
import cn from 'lib/cn';
import React from 'react';

interface Props {
  loading?: boolean;
  dark?: boolean;
  onClick?: () => void;
}

const Dimmer: React.FC<Props> = ({ loading, dark, onClick }) => {
  return (
    <div onClick={onClick} className={cn(styles.dimmer, dark && styles.dark)}>
      {loading && <Loader />}
    </div>
  );
};

export default Dimmer;
